import { Phone } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { Dialog, Box as MuiBox, styled } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { CustomIconProps } from './types';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.common.white}`,
    borderRadius: '0.375rem',
    width: '100%',
    maxWidth: '37.5rem',
    height: '37.5rem',
    paddingTop: '1rem',
    flexGrow: 0,
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      maxWidth: '37.5rem',
      height: '35rem',
      padding: '1.5rem',
    },
  },
}));

export const IconButtonStyled = styled(IconButton)(() => ({
  position: 'absolute',
  right: '8px',
  top: '8px',
  color: 'white',
}));

export const Icon = styled('img')(() => ({
  width: '13.5rem',
}));

export const PhoneIcon = styled(Phone)(() => ({
  fontSize: '2rem',
}));

export const Content = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1.5rem',
  paddingLeft: '1.5rem',
  paddingRight: '1.5rem',
}));

export const RowStep = styled(MuiBox)(({ theme }) => ({
  width: '100%',
}));

export const InfoBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: '0.5rem',
  gap: '0.75rem',
  padding: '0.75rem',
  width: 'auto',
  textAlign: 'center',
}));

export const IconStyled = styled(InfoIcon)<CustomIconProps>(({ customColor }) => ({
  color: customColor,
}));
